import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { TooltipPosition } from '@angular/material/tooltip';
import { SubscriptSizing } from '@angular/material/form-field';
import { passwordRequirementsValidationErrorKey } from '../../../../auth/services/helpers/createPasswordFormControl';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  standalone: false
})
export class PasswordInputComponent {
  @Input() inputControl: FormControl<string>;
  @Input() disabled: boolean;
  @Input() readOnly: boolean;
  @Input() required: boolean;
  @Input() hint: string;
  @Input() labelTextId: string;
  @Input() propertyKey: string;
  @Input() tooltipTextId: string;
  @Input() tooltipPosition: TooltipPosition;
  @Input() placeholder: string;
  @Input() subscriptSizing: SubscriptSizing;

  @Output() focusChange: EventEmitter<boolean>;

  protected hide = true;

  constructor() {
    this.focusChange = new EventEmitter();
  }

  protected readonly passwordRequirementsValidationErrorKey = passwordRequirementsValidationErrorKey;
}
